'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _variables = require('./style/variables');

var _variables2 = _interopRequireDefault(_variables);

var _theme = require('./Popup/theme');

var _theme2 = _interopRequireDefault(_theme);

var _popup = require('./Popup/theme/popup');

var _popup2 = _interopRequireDefault(_popup);

var _confirm = require('./Popup/theme/confirm');

var _confirm2 = _interopRequireDefault(_confirm);

var _alert = require('./Popup/theme/alert');

var _alert2 = _interopRequireDefault(_alert);

var _theme3 = require('./DateInput/theme');

var _theme4 = _interopRequireDefault(_theme3);

var _theme5 = require('./DatePicker/theme');

var _theme6 = _interopRequireDefault(_theme5);

var _theme7 = require('./MonthPicker/theme');

var _theme8 = _interopRequireDefault(_theme7);

var _theme9 = require('./MonthInput/theme');

var _theme10 = _interopRequireDefault(_theme9);

var _theme11 = require('./SearchInput/theme');

var _theme12 = _interopRequireDefault(_theme11);

var _theme13 = require('./ErrorHint/theme');

var _theme14 = _interopRequireDefault(_theme13);

var _theme15 = require('./Tabs/theme');

var _theme16 = _interopRequireDefault(_theme15);

var _theme17 = require('./Menu/theme');

var _theme18 = _interopRequireDefault(_theme17);

var _theme19 = require('./Divider/theme');

var _theme20 = _interopRequireDefault(_theme19);

var _deepmerge = require('deepmerge');

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                p24ComponentsTheme: this._getTheme()
            };
        }

        // you must specify what you’re adding to the context

    }, {
        key: '_getTheme',
        value: function _getTheme() {
            var custom = this.props.theme || {},
                theme = void 0,
                computedPalette = void 0;

            computedPalette = Object.assign({}, _variables2.default, custom.palette);

            theme = Object.assign({
                palette: computedPalette
            }, computedPalette, {
                modal: (0, _theme2.default)(computedPalette),
                dateInput: (0, _theme4.default)(computedPalette),
                datepicker: (0, _theme6.default)(computedPalette),
                monthPicker: (0, _theme8.default)(computedPalette),
                monthInput: (0, _theme10.default)(computedPalette),
                searchInput: (0, _theme12.default)(computedPalette),
                errorHint: (0, _theme14.default)(computedPalette),
                confirmModal: (0, _confirm2.default)(computedPalette),
                alertModal: (0, _alert2.default)(computedPalette),
                popup: (0, _popup2.default)(computedPalette),
                tabs: (0, _theme16.default)(computedPalette),
                menu: (0, _theme18.default)(computedPalette),
                divider: (0, _theme20.default)(computedPalette)
            });

            theme = (0, _deepmerge2.default)(theme, custom);

            return theme;
        }
    }, {
        key: 'render',
        value: function render() {
            // `Children.only` enables us not to add a <div /> for nothing
            return _react2.default.Children.only(this.props.children);
        }
    }]);

    return _class;
}(_react2.default.Component);

_class.propTypes = {
    theme: _propTypes2.default.object,
    children: _propTypes2.default.any.isRequired
};
_class.childContextTypes = {
    p24ComponentsTheme: _propTypes2.default.object
};
_class.defaultProps = {
    theme: {}
};
_class.displayName = 'P24CThemeProvider';
exports.default = _class;